import React, { useState } from 'react';
import { projects } from '../data/mock';
import { stripDiacritics } from '../lib/utils';

const Projects = () => {
  const [filter, setFilter] = useState('Todos');
  const categories = ['Todos', 'Residencial', 'Comercial', 'Industrial'];

  const filteredProjects =
    filter === 'Todos'
      ? projects
      : projects.filter((project) => project.category === filter);

  return (
    <section id="proyectos" className="py-24 bg-[#F2F2F2]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A192F] mb-4">
            Algunos de nuestros{' '}
            <span className="text-[#FFD700]">proyectos destacados</span>
          </h2>
          <p className="text-lg text-[#0A192F]/80 max-w-3xl mx-auto mb-8">
            Descubre cómo transformamos terrazas, fachadas y locales con nuestras soluciones personalizadas.
          </p>

          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all ${
                  filter === category
                    ? 'bg-[#FFD700] text-[#0A192F] shadow-lg'
                    : 'bg-white text-[#0A192F]/70 hover:bg-[#FFD700]/20'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all group"
            >
              <div className="relative overflow-hidden h-64">
                <img
                  src={project.image}
                  alt={stripDiacritics(project.title)}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 px-3 py-1 bg-[#FFD700] rounded-full">
                  <span className="text-[#0A192F] font-semibold text-sm">{project.category}</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#0A192F] mb-2">{project.title}</h3>
                <p className="text-[#0A192F]/70">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;

